import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { Button } from "@/components/ui/button";

export const DonateCTA = () => (
  <section className="py-24 md:py-32 px-5 md:px-10 border-t border-border">
    <div className="max-w-4xl mx-auto text-left">
      <Reveal>
        <p className="text-accent text-sm tracking-[0.2em] uppercase mb-4 font-medium">Get Involved</p>
        <h2 className="font-heading text-3xl md:text-5xl tracking-tight leading-tight">
          Your contribution funds real recovery — one session at a time.
        </h2>
        <p className="text-muted-foreground text-base md:text-lg mt-6 max-w-xl leading-relaxed">
          Every donation is tax-exempt under Section 8 and goes directly towards therapy equipment,
          clinician time, and free community camps.
        </p>
        <Button asChild size="lg" data-testid="cta-donate-button" className="rounded-none bg-accent text-accent-foreground hover:bg-[#C25D3D] hover:scale-[1.03] shadow-lg shadow-accent/30 px-10 h-14 text-base font-semibold tracking-wide mt-8 transition-all group">
          <Link to="/donate">Make a Donation <ArrowRight className="h-4 w-4 ml-2 transition-transform group-hover:translate-x-1" /></Link>
        </Button>
      </Reveal>
    </div>
  </section>
);
